function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/**
 * Purpose: CHECKSENDER opcode — verify transaction sender matches script publickey.
 */

module.exports = {
  name: 'CHECKSENDER',
  description: 'Check transaction sender matches supplied publickey.',
  exampleScript: {
    op: 'CHECKSENDER',
    publickey: '<publickey>'
  },
  execute: function execute(node, context) {
    if (!node || _typeof(node) !== 'object' || !context || _typeof(context) !== 'object') {
      return false;
    }
    var tx = context.tx;
    if (!tx || _typeof(tx) !== 'object' || Array.isArray(tx)) {
      return false;
    }
    var publickey = node.publickey;
    if (typeof publickey !== 'string' || publickey.length === 0) {
      return false;
    }
    var sender = tx.sender;
    if (typeof sender !== 'string' || sender.length === 0) {
      return false;
    }
    return sender.toLowerCase() === publickey.toLowerCase();
  }
};